var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Change Password")]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: { "has-error": _vm.errorMessages.password },
                },
                [
                  _c("label", { staticClass: "control-label col-sm-4" }, [
                    _vm._v("New Password:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { name: "password", type: "password" },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errorMessages.password
                      ? _c("span", { staticClass: "help-block" }, [
                          _vm._v(_vm._s(_vm.errorMessages.password)),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: {
                    "has-error": _vm.errorMessages.passwordConfirmation,
                  },
                },
                [
                  _c("label", { staticClass: "control-label col-sm-4" }, [
                    _vm._v("Repeat:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.passwordConfirmation,
                          expression: "passwordConfirmation",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "password_confirmation",
                        type: "password",
                      },
                      domProps: { value: _vm.passwordConfirmation },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.passwordConfirmation = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errorMessages.passwordConfirmation
                      ? _c("span", { staticClass: "help-block" }, [
                          _vm._v(
                            _vm._s(_vm.errorMessages.passwordConfirmation)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-footer" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: {
                type: "submit",
                click: _vm.handleChangePasswordCallback,
                disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
              },
            },
            [_vm._v("\n        Change Password\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }